{
  "products": [
    {
      "key": "atlanta",
      "name": "Atlanta CityPASS",
      "cityName": {
        "value": "Atlanta"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "atlanta",
      "logoSpot": null
    },
    {
      "key": "boston",
      "name": "Boston CityPASS",
      "cityName": {
        "value": "Boston"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "boston",
      "logoSpot": null
    },
    {
      "key": "chicago",
      "name": "Chicago CityPASS",
      "cityName": {
        "value": "Chicago"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "chicago",
      "logoSpot": null
    },
    {
      "key": "chicago-c3",
      "name": "Chicago C3",
      "cityName": {
        "value": "Chicago"
      },
      "type": "c3",
      "thumb": null,
      "slug": "chicago-c3",
      "logoSpot": null
    },
    {
      "key": "dallas",
      "name": "Dallas CityPASS",
      "cityName": {
        "value": "Dallas"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "dallas",
      "logoSpot": null
    },
    {
      "key": "denver",
      "name": "Denver CityPASS",
      "cityName": {
        "value": "Denver"
      },
      "type": "cx",
      "thumb": null,
      "slug": "denver",
      "logoSpot": null
    },
    {
      "key": "houston",
      "name": "Houston CityPASS",
      "cityName": {
        "value": "Houston"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "houston",
      "logoSpot": null
    },
    {
      "key": "new-york",
      "name": "New York CityPASS",
      "cityName": {
        "value": "New York"
      },
      "type": "core",
      "thumb": null,
      "slug": "new-york",
      "logoSpot": null
    },
    {
      "key": "new-york-c3",
      "name": "New York C3",
      "cityName": {
        "value": "New York"
      },
      "type": "c3",
      "thumb": null,
      "slug": "new-york-c3",
      "logoSpot": null
    },
    {
      "key": "new-york-c-all",
      "name": "New York C-All",
      "cityName": {
        "value": "New York"
      },
      "type": "call",
      "thumb": null,
      "slug": "new-york-c-all",
      "logoSpot": null
    },
    {
      "key": "orlando",
      "name": "Orlando CityPASS",
      "cityName": {
        "value": "Orlando"
      },
      "type": "alacarte",
      "thumb": null,
      "slug": "orlando",
      "logoSpot": null
    },
    {
      "key": "philadelphia",
      "name": "Philadelphia CityPASS",
      "cityName": {
        "value": "Philadelphia"
      },
      "type": "cx",
      "thumb": null,
      "slug": "philadelphia",
      "logoSpot": null
    },
    {
      "key": "san-diego",
      "name": "San Diego CityPASS",
      "cityName": {
        "value": "San Diego"
      },
      "type": "cxplus",
      "thumb": null,
      "slug": "san-diego",
      "logoSpot": null
    },
    {
      "key": "san-francisco",
      "name": "San Francisco CityPASS",
      "cityName": {
        "value": "San Francisco"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "san-francisco",
      "logoSpot": null
    },
    {
      "key": "san-francisco-c3",
      "name": "San Francisco C3",
      "cityName": {
        "value": "San Francisco"
      },
      "type": "c3",
      "thumb": null,
      "slug": "san-francisco-c3",
      "logoSpot": null
    },
    {
      "key": "seattle",
      "name": "Seattle CityPASS",
      "cityName": {
        "value": "Seattle"
      },
      "type": "corechoice",
      "thumb": null,
      "slug": "seattle",
      "logoSpot": null
    },
    {
      "key": "seattle-c3",
      "name": "Seattle C3",
      "cityName": {
        "value": "Seattle"
      },
      "type": "c3",
      "thumb": null,
      "slug": "seattle-c3",
      "logoSpot": null
    },
    {
      "key": "southern-california",
      "name": "Southern California CityPASS",
      "cityName": {
        "value": "Southern California"
      },
      "type": "alacarte",
      "thumb": null,
      "slug": "southern-california",
      "logoSpot": null
    },
    {
      "key": "tampa",
      "name": "Tampa Bay CityPASS",
      "cityName": {
        "value": "Tampa Bay"
      },
      "type": "core",
      "thumb": null,
      "slug": "tampa",
      "logoSpot": null
    },
    {
      "key": "toronto",
      "name": "Toronto CityPASS",
      "cityName": {
        "value": "Toronto"
      },
      "type": "core",
      "thumb": null,
      "slug": "toronto",
      "logoSpot": null
    }
  ]
}
